/**
 * Extracts YouTube video ID from various URL formats
 * 
 * Supports:
 * - Standard: https://www.youtube.com/watch?v=VIDEO_ID
 * - Short: https://youtu.be/VIDEO_ID
 * - Embed: https://www.youtube.com/embed/VIDEO_ID
 * - With timestamp: https://www.youtube.com/watch?v=VIDEO_ID&t=30s
 * - With playlist: https://www.youtube.com/watch?v=VIDEO_ID&list=PLAYLIST_ID
 */
export function extractYouTubeId(url: string | null | undefined): string {
  // Handle null, undefined, or empty strings - EXTRA SAFE VERSION
  if (!url || typeof url !== 'string' || url.trim() === '') {
    return '';
  }

  // If it's already just an ID (11 characters), return it
  if (url.length === 11 && !url.includes('/') && !url.includes('?')) {
    return url;
  }

  // Try to match different YouTube URL patterns
  const patterns = [
    /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([a-zA-Z0-9_-]{11})/,
    /youtube\.com\/watch\?.*v=([a-zA-Z0-9_-]{11})/,
  ];

  for (const pattern of patterns) {
    const match = url.match(pattern);
    if (match && match[1]) {
      return match[1];
    }
  }

  // If no pattern matched, return the original string
  // (in case it's already a video ID)
  return url;
}